// /src/hooks/usePageNavigation.js
import { useEffect, useState } from "react";
import { changeMainPage, changePage, UPDATE_PAGE, MAIN_PAGE } from "../../redux_store/appState";

const usePageNavigation = ({ dispatch }) => {
    const [popEventSet, setPopEventSet] = useState(false);

    useEffect(() => {
        if (!popEventSet) {
            window.onpopstate = (event) => {
                if (event?.state?.MAIN_PAGE?.page) {
                    dispatch(changeMainPage(event.state.MAIN_PAGE.page, false));
                } else {
                    dispatch({ type: UPDATE_PAGE, value: MAIN_PAGE });
                    dispatch(changeMainPage("Recall", false));
                }
            };
            setPopEventSet(true);
        }
    }, [popEventSet, dispatch]);
};

export default usePageNavigation;
